import "./Home.css";
import ProductCard from '../ProductCard/ProductCard';
import {useState, useEffect} from "react";
import {SyncLoader} from "react-spinners";
import {useParams} from "react-router-dom";
import {Link} from 'react-router-dom';

export default function Filter() {

    const [products, setProducts] = useState();
    const query = useParams().query;

    useEffect(() => {
        fetch("/backend/database.json", { cache: "no-store" })
            .then(response => {
                return response.json()
            })
            .then(data => {
                setProducts(data);
            })
    }, [])

    return (
        <>
            <div id="filterInfoContainer">
                <h1>
                    Filtri applicati: <strong>{query}</strong>
                </h1>
                <Link id="removeFilterButton" to="/">
                    RIMUOVI I FILTRI
                </Link>
            </div>
            {
                products ?
                    <div id="productsContainer">
                        {products[query].map(item => (
                            <ProductCard key={item.id} product={item} />
                            ))
                        }
                    </div> :
                    <SyncLoader
                        className="dotLoader"
                        color="#ffffff"
                        size={12}
                    />
            }
        </>
    )
}
